"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderChildren = void 0;
var tslib_1 = require("tslib");
var h = require("./../../utils/createElement").h;
var React = tslib_1.__importStar(require("react"));
function renderChildren(props, checkedValues, handleSingleChange, Component, itemStyle) {
    var children = props.children;
    var options = props.options || [];
    var disabled = props.disabled;
    var style = tslib_1.__assign({ paddingBottom: 18 }, itemStyle);
    if (options.length) {
        return options.map(function (option, index) {
            if (typeof option === 'string') {
                return (h(Component, { key: index, value: option, onChange: handleSingleChange, checked: checkedValues.indexOf(option) !== -1, disabled: disabled, style: tslib_1.__assign({}, style) }, option));
            }
            else {
                return (h(Component, tslib_1.__assign({}, option, { key: index, value: option.value, onChange: handleSingleChange, checked: checkedValues.indexOf(option.value) !== -1, disabled: option.disabled || disabled, style: tslib_1.__assign(tslib_1.__assign({}, style), option.style) }), option.label));
            }
        });
    }
    return React.Children.map(children, function (child) {
        return React.cloneElement(child, {
            checked: checkedValues.indexOf(child.props.value) !== -1,
            onChange: handleSingleChange,
            disabled: child.props.disabled || disabled,
            style: tslib_1.__assign(tslib_1.__assign({}, style), child.props.style)
        });
    });
}
exports.renderChildren = renderChildren;
